import api from '../../api';
import { push } from 'connected-react-router';
import { store as storeNotification } from 'react-notifications-component';
import { socket } from './../store/socket';

const notificationConfig = {
  container: 'top-center',
  animationIn: ['animated', 'fadeIn'],
  animationOut: ['animated', 'fadeOut'],
  dismiss: {
    duration: 1500,
    showIcon: true
  }
};

export const typeSchedulesStartRequest = () => {
  return {
    type: 'TYPE_SCHEDULES_START_REQUEST'
  };
};

export const typeSchedulesEndRequest = () => {
  return {
    type: 'TYPE_SCHEDULES_END_REQUEST'
  };
};

export const getAllTypeSchedulesSuccess = ({ data }) => {
  return {
    type: 'TYPE_SCHEDULES_GET_ALL_SUCCESS',
    payload: data
  };
};

export const getAllTypeSchedulesError = error => {
  return {
    type: 'TYPE_SCHEDULES_GET_ALL_ERROR',
    payload: error
  };
};

export const addTypeSchedulesSuccess = ({ data }) => {
  return {
    type: 'TYPE_SCHEDULES_ADD_SUCCESS',
    payload: data
  };
};

export const addTypeSchedulesError = error => {
  return {
    type: 'TYPE_SCHEDULES_ADD_ERROR',
    payload: error
  };
};

export const editTypeSchedulesSuccess = ({ data }) => {
  return {
    type: 'TYPE_SCHEDULES_EDIT_SUCCESS',
    payload: data
  };
};

export const editTypeSchedulesError = error => {
  return {
    type: 'TYPE_SCHEDULES_EDIT_ERROR',
    payload: error
  };
};

export const removeTypeSchedulesSuccess = id => {
  return {
    type: 'TYPE_SCHEDULES_REMOVE_SUCCESS',
    payload: id
  };
};

export const removeTypeSchedulesError = error => {
  return {
    type: 'TYPE_SCHEDULES_REMOVE_ERROR',
    payload: error
  };
};

export const typeSchedulesModifyStore = ({ data }) => {
  return {
    type: 'TYPE_SCHEDULES_MODIFY_STORE',
    payload: data
  };
};

export const addTypeSchedules = (data, formReset, submitBtn) => {
  return async dispatch => {
    try {
      submitBtn.disabled = true;
      dispatch(typeSchedulesStartRequest());
      const response = await api().post('/api/type_schedules', data);
      dispatch(addTypeSchedulesSuccess(response));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'ADD',
        module: 'typeSchedules',
        data: [response.data],
        company: response.data.company
      });
      formReset();
    } catch (err) {
      dispatch(addTypeSchedulesError(err));
    } finally {
      document
        .getElementsByClassName('page-content')[0]
        .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      setTimeout(() => {
        dispatch(typeSchedulesEndRequest());
        submitBtn.disabled = false;
      }, 1800);
    }
  };
};

export const getAllTypeSchedules = (params = {}) => {
  return async dispatch => {
    try {
      dispatch(typeSchedulesStartRequest());
      const response = await api().get('/api/type_schedules', { params });
      dispatch(getAllTypeSchedulesSuccess(response));
    } catch (err) {
      dispatch(getAllTypeSchedulesError(err));
    } finally {
      dispatch(typeSchedulesEndRequest());
    }
  };
};

export const editTypeSchedules = (data, submitBtn = {}, handleModalClose) => {
  return async dispatch => {
    const defaultMsg = button => {
      return new Promise(resolve => {
        document
          .getElementsByClassName('page-content')[0]
          .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        setTimeout(() => {
          dispatch(typeSchedulesEndRequest());
          button.disabled = false;
          resolve(true);
        }, 1800);
      });
    };

    try {
      submitBtn.disabled = true;
      dispatch(typeSchedulesStartRequest());
      const id = data._id;
      const response = await api().put('/api/type_schedules/' + id, data);
      dispatch(editTypeSchedulesSuccess(response));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'EDIT',
        module: 'typeSchedules',
        data: [response.data],
        company: response.data.company
      });
      await defaultMsg(submitBtn);
      if (handleModalClose) {
        handleModalClose();
      } else {
        dispatch(push('/type_schedules'));
      }
    } catch (err) {
      dispatch(editTypeSchedulesError(err));
      await defaultMsg(submitBtn);
    }
  };
};

export const removeTypeSchedules = id => {
  return async dispatch => {
    try {
      dispatch(typeSchedulesStartRequest());
      await api().delete('/api/type_schedules/' + id);
      dispatch(removeTypeSchedulesSuccess(id));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'REMOVE',
        module: 'typeSchedules',
        data: id
      });
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Tipo de agendamento removido com sucesso.',
          type: 'success'
        });
      }, 300);
    } catch (err) {
      dispatch(removeTypeSchedulesError(err));
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Falha ao remover tipo de agendamento.',
          type: 'danger'
        });
      }, 300);
    } finally {
      document
        .getElementsByClassName('page-content')[0]
        .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      dispatch(typeSchedulesEndRequest());
    }
  };
};

export const restoreTypeSchedules = data => {
  return async dispatch => {
    try {
      dispatch(typeSchedulesStartRequest());
      const id = data._id;
      const response = await api().put('/api/type_schedules/' + id, data);
      dispatch(editTypeSchedulesSuccess(response));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'RESTORE',
        module: 'typeSchedules',
        data: [response.data],
        company: response.data.company
      });
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Tipo de agendamento restaurado com sucesso.',
          type: 'success'
        });
      }, 300);
    } catch (err) {
      dispatch(editTypeSchedulesError(err));
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Falha ao restaurar tipo de agendamento.',
          type: 'danger'
        });
      }, 300);
    } finally {
      document
        .getElementsByClassName('page-content')[0]
        .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      dispatch(typeSchedulesEndRequest());
    }
  };
};
